

import icons from "url:../../img/icons.svg";
import View from "./view.js";


class Pagination extends View {
    _parentEl = document.querySelector('.pagination');


    addHandlerRender(handler) {
        this._parentEl.addEventListener("click", function(event) {
            const button = event.target.closest(".btn--inline");
            if (!button) return;

            handler(+button.dataset.goto);
        });
    }


    _generateMarkup() {
        const currentPage = this._data.page;
        const numOfPages = Math.ceil(this._data.recipes.length / this._data.resultsPerPage);

        // Scenario A: We are in Page 1 and other pages exist
        if (currentPage === 1 && numOfPages > 1) {
            return this._generateNextBtnMarkup(currentPage)
        }

        // Scenario B: We are in Page 1 and other pages do not exist
        if (currentPage === numOfPages && numOfPages === 1) return "";

        // Scenario C: We are in some other page (neither the first nor the last)
        if (currentPage !== 1 && currentPage !== numOfPages) {
            return this._generatePrevBtnMarkup(currentPage) + this._generateNextBtnMarkup(currentPage);
        }

        // Scenario D: We are in the last page
        if (currentPage === numOfPages && numOfPages > 1) {
            return this._generatePrevBtnMarkup(currentPage);
        }
    }


    _generatePrevBtnMarkup(page) {
        return `
            <button class="btn--inline pagination__btn--prev" data-goto="${page - 1}">
                <svg class="search__icon">
                    <use href="${icons}#icon-arrow-left"></use>
                </svg>
                <span>Page ${page - 1}</span>
            </button>
        `;
    }


    _generateNextBtnMarkup(page) {
        return `
            <button class="btn--inline pagination__btn--next" data-goto="${page + 1}">
            <span>Page ${page + 1}</span>
                <svg class="search__icon">
                    <use href="${icons}#icon-arrow-right"></use>
                </svg>
            </button>
        `;
    }
}


export default new Pagination();